import { Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-previous-point-title',
  standalone: true,
  imports: [
    TranslateModule
  ],
  templateUrl: './previous-point-title.component.html',
  styleUrls: ['./previous-point-title.component.scss'],
})
export class PreviousPointTitleComponent {
  public previousPointTitle = input<string>();
}
